import { Event } from '../global/event.js';

export class Summary extends Event {
    constructor() {
        super();
        this.scrollLock = false;
        this.offers = document.querySelector('.offers');
        this.summary = document.querySelector('#summary');
        this.summaryToggler = document.querySelector('.summary-toggle');
        this.steps = document.querySelectorAll('.steps');
        this.formsEnd = document.querySelector('.formsend');
        this.footerLogo = document.querySelector('.footerlogo');
        this.footerdiv = document.querySelector('footer');
        this.footerMenu = document.querySelector('footer .footermenu');
        this.submitArea = document.querySelector('.summary_ph');
        this.inputBonustext = document.querySelector('input[name="order[bonustext]"]');
        this.ausgabe = document.querySelector('#ad_newspaper');
        this.deliverstart = document.querySelector('#ad_deliverystart');
        this.payment = document.querySelector('#ad_payway');
        this.duration = document.querySelector('#ad_duration');
        this.loginCe = document.querySelector('.loginregister');
        
        this.offer = document.querySelector('#summay-offer');
        this.price = document.querySelector('#summary-price-offer');
        this.total = document.querySelector('#price .price_total');
        
        this.device = {
            holder : document.querySelector('#summary-price-device'),
            title : document.querySelector('#summary-price-device .summary-device-title'),
            value : document.querySelector('#summary-price-device .summary-device-price'),
            infoholder : document.querySelector('#summary-device-holder'),
            info : document.querySelector('#summary-device'),
            variant : document.querySelector('#summary-device-variant'),
        };
        
        this.upsell = {
            holder : document.querySelector('#summary-price-upsell'),
            title : document.querySelector('#summary-price-upsell .summary-upsell-title'),
            value : document.querySelector('#summary-price-upsell .summary-upsell-price'),
        };
        
        this.addon = {
            holder : document.querySelector('#summary-price-addon'),
            title : document.querySelector('#summary-price-addon .summary-addon-title'),
            value : document.querySelector('#summary-price-addon .summary-addon-price')
        };
        
        this.surcharge = {
            holder : document.querySelector('#summary-surcharge'),
            title : document.querySelector('#summary-surcharge .summary-surcharge-title'),
            value : document.querySelector('#summary-surcharge .summary-surcharge-price'),
        }
        
        this.rabat = {
            holder : document.querySelector('#summary-price-rabat'),
            value : document.querySelector('#summary-price-rabat .summary-rabat-price'),
        }
        
        this._lastLoaderPrice = false;
        this.init();
    };

    get visibleStep() {
        let element = false;

        if (this.loginCe) {
            return this.loginCe;
        }

        if(this.steps) {
            this.steps.forEach(step => {
                if(!element && this.isVisible(step) && !step.classList.contains('summary-block')) {
                    element = step;
                }
            });
        }
        return element;
    };

    init() {
        let body = document.querySelector('body');
        body.classList.add('landingpage');
        body.addEventListener('scroll', () => {
            this.updatePosition();
        }, {passive: true});

        this.summary.addEventListener('wheel', event => {
            body.scrollTop += event.deltaY;
        }, {passive: true});
        
        this.summary.addEventListener('click', () => {
            this.toggleSummary();
        });
    };

    updatePosition() {
        if (window.innerWidth >= 992 && this.visibleStep) {
            let visibleStep = this.visibleStep.getBoundingClientRect();
            let parentPosition = parseInt(visibleStep.top + visibleStep.height);// + 15;
            let summary = this.summary.getBoundingClientRect();
            let submitArea = this.submitArea.getBoundingClientRect();
            let submitButton = this.formsEnd.getBoundingClientRect();
            let bottomCheck = parseInt(submitArea.bottom - submitButton.height - 22);
            
            if(parseInt(summary.bottom) >= bottomCheck && this.scrollLock) {
                parentPosition = parseInt(submitArea.bottom - summary.height - submitButton.height - 22);
                this.scrollLock = false;
            } else {
                if(parentPosition <= 20 && this.scrollLock) {
                    parentPosition = 20;
                }
                if(parentPosition <= 20 && !this.scrollLock) {
                    parentPosition = parseInt(submitArea.bottom - summary.height - submitButton.height - 22);
                }
            }

            this.summary.style.position = 'fixed';
            this.summary.style.width = submitArea.width + 'px';
            this.summary.style.top = parseInt(parentPosition) + 'px';
            
            if (submitArea.top <= (summary.bottom + 22) ) {
                this.formsEnd.style.position = 'fixed';
                this.formsEnd.style.width = submitArea.width + 'px';
                this.formsEnd.style.top = (summary.bottom + 22) + 'px';
            } else {
                this.formsEnd.style.position = 'relative';
                this.formsEnd.style.top = 'auto';
            }

            if(summary.top >= 20) {
                this.scrollLock = true;
            }
        } else if (window.innerWidth < 992) {
            let toggle = this.summaryToggler.getBoundingClientRect();
            let diffButton = (toggle.top + toggle.height) - window.innerHeight;
            if(diffButton <= 0) {
                this.staticSummary(true);
            } else {
                this.staticSummary(false);
            }
        }
    };

    staticSummary(isStatic) {
        if (isStatic) {
            this.summary.classList.add('static');
        } else {
            this.summary.classList.remove('static');
        }
    };

    toggleSummary() {
        if (window.innerWidth < 992) {
            if(this.summary.classList.contains('active')) {
                this.summary.classList.remove('active');
                this.summary.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                this.footerdiv.style.paddingBottom = '';
            } else {
                this.summary.classList.add('active');
                this.footerdiv.style.paddingBottom = this.summary.offsetHeight + 'px';
            }
        }
    };
    
    updateSteps() {
        let steps = document.querySelectorAll('.steps');
        let maxSteps = 0;
        let actStep = 1;
        if(steps) {
            steps.forEach(step => {
                if(!step.classList.contains('d-none')) {
                    maxSteps++;
                }
            });
            steps.forEach(step => {
                if(!step.classList.contains('d-none')) {
                    let element = step.querySelector('.step strong');
                    if(element) {
                        element.innerHTML = '<strong>Schritt ' + actStep + ' von ' + maxSteps + '</strong>';
                        actStep++;
                    }
                }
            });
        }
    };

    priceLoader() {
        let element = document.querySelector('#summary-price-offer .summary-offer-price:last-child');
        if(element) {
            this._lastLoaderPrice = {
                element : element,
                value : element.innerHTML
            };
            element.innerHTML = '<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>';
        }
    };
    
    removeLoader() {
        if(this._lastLoaderPrice) {
            this._lastLoaderPrice.element.innerHTML = this._lastLoaderPrice.value;
            this._lastLoaderPrice = false;
        }
    }

    updateInput(element, value) {
        let elements = document.querySelector('#summary-'+element);
        if(elements) {
            elements.innerHTML = value;
        }
    };

    updateAusgabe(value) {
        this.ausgabe.innerHTML = '<strong>Ausgabe: </strong>' + value;
    };

    updateDeliveryStart(value) {
        this.deliverstart.innerHTML = '<strong>Beginn: </strong>' + value;
    };

    updatePayment(value) {
        this.payment.innerHTML = '<strong>Zahlung: </strong>' + value;
    };

    updatePriceTotal(value) {
        this.total.innerHTML = OVS.app.helper.humanPrice(value) + ' €';
    };

    updatePriceOffer(value, updatePrice = false) {
        if(updatePrice) {
            let summaryOfferPrices = document.querySelectorAll('.summary-offer-price');
            for(let i = 0; i < value.length; i++) {
                summaryOfferPrices[i].innerHTML = OVS.app.helper.humanPrice(value[i].value) + ' €';
            }
        } else {
            if (typeof value !== 'boolean') {
                this.price.innerHTML = '';
                if (typeof value == 'object') {
                    value.forEach((v,k) => {
                        if (k == 0 && !v.title) {
                            v.title = 'Abo'
                        }
                        if (v.title && v.title != '') {
                            this.addPriceRow(v.title, v.value);
                        }
                    });
                } else {
                    this.addPriceRow('Abo', v.value);
                }
            }
        }
        this.updatePosition();
        this.fireEvent('summaryUpdated');
    };
    
    addPriceRow(title, value) {
        let span1 = document.createElement('span');
        let span2 = document.createElement('span');
        
        span1.classList.add('summary-offer-title');
        span1.classList.add('infofield');
        span1.innerHTML = title;
        
        span2.classList.add('summary-offer-price');
        span2.classList.add('infofield');
        span2.classList.add('text-end');
        span2.innerHTML = OVS.app.helper.humanPrice(value) + ' €';
        
        this.price.append(span1);
        this.price.append(span2);
    }

    updateUpselling(value) {
        if(value.value > 0) {
            this.upsell.holder.classList.remove('d-none');
            this.upsell.title.innerHTML = '+ ' + value.title;
            this.upsell.value.innerHTML = OVS.app.helper.humanPrice(value.value) + ' €';
        } else {
            this.upsell.holder.classList.add('d-none');
            this.upsell.title.innerHTML = '';
            this.upsell.value.innerHTML = '';
        }
        this.updatePosition();
        this.fireEvent('summaryUpdated');
    };
    
    updateDevice(title = false, text = false, summary = false) {
        this.device.title.innerHTML = '+ ' + summary + ' monatlich';
        if(title) {
            this.device.info.classList.remove('d-none');
            this.device.info.innerHTML = title;
        } else {
            this.device.info.classList.add('d-none');
            this.device.info.innerHTML = '';
        }

        if(text) {
            this.device.variant.classList.remove('d-none');
            this.device.variant.innerHTML = text;
        } else {
            this.device.variant.classList.add('d-none');
            this.device.variant.innerHTML = '';
        }
        
        if(!title && !text) {
            this.device.infoholder.classList.add('d-none');
        } else {
            this.device.infoholder.classList.remove('d-none');
        }
        
        if(this.inputBonustext) { 
            this.inputBonustext.value = (title && text) ? title + ' ' + text : '';
        }
    };

    updatePriceDevice(value) {
        if(typeof value == 'number' && !this.device.title.innerHTML.includes("false",)) {
            this.device.holder.classList.remove('d-none');
            this.device.value.innerHTML = OVS.app.helper.humanPrice(value) + ' €';
        } else {
            this.device.holder.classList.add('d-none');
            this.device.value.innerHTML = '';
        }
        this.updatePosition();
        this.fireEvent('summaryUpdated');
    };

    updatePriceSurcharge(surcharge) {
        if(surcharge.bonus > 0) {
            this.surcharge.holder.classList.remove('d-none');
            this.surcharge.value.innerHTML = OVS.app.helper.humanPrice(surcharge.bonus) + ' €';
        } else {
            this.surcharge.holder.classList.add('d-none');
            this.surcharge.value.innerHTML = '';
        }
        this.updatePosition();
    };

    updateAddon(title = '', price = null) {
        if(title != '') {
            this.addon.holder.classList.remove('d-none');
            this.addon.title.innerHTML = '+ ' + title;
            this.addon.value.innerHTML = OVS.app.helper.humanPrice(price) + ' €';
        } else {
            this.addon.holder.classList.add('d-none');
            this.addon.title.innerHTML = '';
            this.addon.value.innerHTML = '';
        }
        this.updatePosition();
    };

    updateProduct(title, runtime) {
        this.offer.innerHTML = title;
        if(runtime == 0)
            this.duration.innerHTML = '';
        else
            this.duration.innerHTML = '<strong>Laufzeit: </strong>' + runtime;
    };

    updateRabat(rabat) {
        if(rabat > 0) {
            this.rabat.holder.classList.remove('d-none');
            this.rabat.value.innerHTML = rabat + '%';
        } else {
            this.rabat.holder.classList.add('d-none');
            this.rabat.value.innerHTML = '';
        }
        this.updatePosition();
    }

    isVisible(e) {
        return !!( e.offsetWidth || e.offsetHeight || e.getClientRects().length );
    };

    hideBlock(block) {
        let element = document.querySelector('#summary-block-' + block);
        if(element) {
            element.classList.add('d-none');
        }
    };
};
